import redirectInterceptor from "@/interceptors/redirect_interceptor";
import router from "@/router";

const getDefaultState = () => ({
  voyageRelativeWindData: null,
  fetchLoading: false,
  fetchError: null
});

const state = getDefaultState();

const getters = {
  chartOptions: (state) => ({
    chart: {
      polar: true,
      type: "column",
    },
    title: { text: null },
    tooltip: {
      distance: 5,
      valueSuffix: " %",
      valueDecimals: 1,
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      width: "100%",
      itemStyle: { fontSize: "10px" },
    },
    xAxis: {
      categories: [
        "AHEAD", "22.5", "45", "67.5", "ABEAM", "112.5", "135", "157.5",
        "ASTERN", "202.5", "225", "247.5", "270", "292.5", "315", "337.5",
      ],
      tickmarkPlacement: "on",
    },
    yAxis: { min: 0 },
    plotOptions: {
      series: {
        stacking: "normal",
        pointPlacement: "on",
      },
    },
    credits: { enabled: false },
    series: state.voyageRelativeWindData || [],
  })
};

const actions = {
  async fetchVoyageRelativeWindData({ commit }, data) {
    commit("SET_LOADING");

    const baseUrl = process.env.VUE_APP_BASIC_URL;
    const response = await redirectInterceptor.get(
      `${baseUrl}/vesselInformation/${data.name}/voyageWindData`,
      {
        params: {
          startDate: data.startDate,
          stopDate: data.stopDate
        },
        headers: {
          Authorization: localStorage.getItem("quad_token")
        }
      }
    );

    if (response.status === 200) {
      commit("SET_SUCCESS", response.data);
    } else {
      if (response.data && response.data.msg === "rdr") {
        router.push("/login");
      }
      commit("SET_ERROR");
    }
  }
};

const mutations = {
  SET_LOADING(state) {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_SUCCESS(state, data) {
    state.voyageRelativeWindData = data;
    state.fetchLoading = false;
  },
  SET_ERROR(state) {
    state.fetchLoading = false;
    state.fetchError = "Failed to load relative wind data";
  }
};

export const voyageRelativeWindDataModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
